import { Injectable } from '@angular/core';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { MediaPartnersFilter } from '../models/impact-partners.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class ImpactPartnersService {
  constructor(private http: HttpService) {}

  addMediaPartner(payload: any) {
    return this.http.post(`${URLS.mediaContacts}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  getMediaPartners(filter: MediaPartnersFilter) {
    return this.http.get(
      `${URLS.mediaContacts}?page=${filter.pageNumber}&limit=${filter.limit}`,
      {
        params: { headerType: HeaderType.ACCESS },
      }
    );
  }

  updateMediaPartner(partnerId: string, payload: any) {
    return this.http.patch(`${URLS.mediaContacts}/${partnerId}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  deleteMediaPartner(partnerId: string) {
    return this.http.delete(`${URLS.mediaContacts}/${partnerId}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
}
